<template>
    <div class="pa-5" v-if="activeRule">
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Description" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeRule.description ? activeRule.description : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Info provider" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeRule.info_provider ? capitalizeFirstLetter(activeRule.info_provider) : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3"
                >{{ activeRule.info_provider === "odoo" ? t("Export client") : t("Store") }}
            </v-col>
            <v-col class="col-item" cols="6">
                {{
                    activeRule.info_provider === "odoo"
                        ? activeRule.related_export_client_name || "-"
                        : activeRule.related_store_name || "-"
                }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3"
                >{{ activeRule.info_provider === "odoo" ? t("Client") : t("Tag") }}
            </v-col>
            <v-col class="col-item" cols="6">
                {{
                    activeRule.info_provider === "odoo"
                        ? activeRule.related_client_name || "-"
                        : activeRule.related_tag_name || "-"
                }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Start date" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeRule.start_date ? activeRule.start_date : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "End date" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeRule.end_date ? activeRule.end_date : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Percent" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeRule.percent ? `${activeRule.percent.toFixed(2)}%` : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Sum" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeRule.amount ? `${activeRule.amount.toFixed(2)}` : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Entry type" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeRule.entry_type ? capitalizeFirstLetter(activeRule.entry_type) : "-" }}
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { helperMixin } from "@/mixins/helper-mixin";

export default {
    name: "general-tab",
    data() {
        return {};
    },
    computed: {
        ...mapState("RuleStore", ["activeRule"])
    },
    mixins: [helperMixin]
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 2px;
    padding-bottom: 2px;
}
</style>
